import { environment } from "./../../../../environments/environment";
import { Component, OnInit, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";

import { LocalStorageService } from "src/app/utils/localstorage.service";
import { AccountantService } from "./accountant.service";
import { DashboardService } from "../../dashboard.service";
import { BsModalRef } from "ngx-bootstrap/modal";
import { HotToastService } from "@ngneat/hot-toast";
import * as _ from "underscore";
import { StripeService } from "./stripe.service";
import {
  SharedDataService,
  SubscriptionErrorStatus,
} from "../../shared-data.service";

declare var jQuery: any;
declare var Stripe: any;
/**
 * Dashboard main page component. It's empty for now
 */
@Component({
  selector: "app-subscription",
  templateUrl: "./subscription.component.html",
  styleUrls: ["./subscription.component.scss"],
  standalone: true,
})
export class SubscriptionComponent implements OnInit {
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  user: any = {};
  data: any = { user_type: null };
  company: any = {};
  is_owner: boolean = false;
  loading = false;

  stripe = Stripe(environment.stripeKey);
  card: any;
  elements: any;

  SubscriptionErrorStatus = SubscriptionErrorStatus;

  constructor(
    private localStorage: LocalStorageService,
    private accountantService: AccountantService,
    private dashboardService: DashboardService,
    private toastr: HotToastService,
    private router: Router,
    private stripeService: StripeService,
    public sharedDataService: SharedDataService,
  ) {}

  ngOnInit(): void {
    if (this.sharedDataService.data.stripe_subscription_status != "canceled") {
      this.router.navigate(["../practice/workspaces"]);
      return;
    }

    this.elements = this.stripe.elements();
    var style = {
      base: {
        color: "#32325d",
        lineHeight: "18px",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    };
    this.card = this.elements.create("card", { style: style });
    this.card.mount("#card-element");
    this.card.addEventListener("change", function (event) {
      var displayError = document.getElementById("card-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = "";
      }
    });
    var form = document.getElementById("payment-form");
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      this.dashboardService.show_loading.next(true);
      this.stripe.createToken(this.card).then((result: any) => {
        if (result.error) {
          var errorElement = document.getElementById("card-errors");
          errorElement.textContent = result.error.message;
        } else {
          this.subscribeAgain(result.token);

          // this.accountantService.add_payment_method(result.token).then(
          //   (res: any) => {
          //     this.toastr.success("Success!", res.message);
          //     this.sharedDataService.data.error_status = [];

          //     this.dashboardService.show_loading.next(false);
          //     this.dashboardService.paymentDone.next(true);
          //   },
          //   (err) => {
          //     this.toastr.error("Error", err);

          //     this.localStorage.set("data", this.data);
          //     this.dashboardService.show_loading.next(false);
          //   },
          // );
        }
      });
    });

    if (this.sharedDataService.data.user_type == 1) {
      this.accountantService.get_subscription_status().then((res: any) => {
        this.sharedDataService.data.tier = res.subscription.tier;
        this.sharedDataService.data.error_status =
          res.subscription.error_status;
        this.sharedDataService.data.stripe_subscription_status =
          res.subscription.stripe_subscription_status;

        console.log("RES SUBSCRIPTION", res.subscription, this.user);

        this.is_owner = res.subscription.owner == this.user.id;

        if (
          this.sharedDataService.data.stripe_subscription_status != "canceled"
        ) {
          this.router.navigate(["../practice/workspaces"]);
          return;
        }
      });
    }
  }

  subscribeAgain(token) {
    this.dashboardService.show_loading.next(true);

    // create new subscription with trial and save payment method
    this.accountantService.subscribeAgain(token).then(
      (res: any) => {
        if (this.sharedDataService.data.user_type == 1) {
          this.accountantService
            .get_subscription_status()
            .then((status: any) => {
              this.sharedDataService.data.tier = status.subscription.tier;
              this.sharedDataService.data.error_status =
                status.subscription.error_status;
              this.sharedDataService.data.stripe_subscription_status =
                status.subscription.stripe_subscription_status;

              console.log("RESUB", status.subscription, this.user);

              this.dashboardService.show_loading.next(false);
              this.toastr.success(res.message);

              setTimeout(() => {
                this.sharedDataService.subscriptionType =
                  status.subscription.type;
              }, 2000);

              this.router.navigate(["../practice/workspaces"]);

              this.is_owner = status.subscription.owner == this.user.id;
            });
        }
      },
      (err: any) => {
        this.toastr.error("Subscription failed");
        this.dashboardService.show_loading.next(false);
      },
    );
  }
  // this.accountantService.subscribeAgain(token).then(}

  goToCustomerPortal() {
    this.loading = true;
    this.stripeService
      .getCustomerPortalSession()
      .subscribe((res: any) => (window.location.href = res.url));
  }
}
